/**
 * 调试面板房间信息模块。
 */
import { socket } from "@/services/remote/socket";
import { useConnectionStore } from "@/stores/remote";

/**
 * 展示房间信息并提供基础操作。
 */
export function RoomSection() {
	const {
		currentRoomId,
		setCurrentRoomId,
		participants,
		lastHeartbeat,
		isOtherParticipantOnline,
		resetRoom,
	} = useConnectionStore();

	return (
		<div className="flex w-full flex-row my-2 gap-2">
			<div className="text-sm text-gray-500 w-1/2">
				<ul>
					<li>
						Current Room ID:
						{currentRoomId ?? "none"}
					</li>
					<li>Participants: {participants.length}</li>
					<li>Last Heartbeat: {lastHeartbeat}</li>
					<li>
						Is Other Participant Online:{" "}
						{isOtherParticipantOnline ? "Yes" : "No"}
					</li>
				</ul>
			</div>

			<div className="flex w-1/2 gap-2 flex-wrap">
				<button
					type="button"
					className="btn btn-sm btn-default"
					onClick={async () => {
						socket.emit("check-room", (response: unknown) => {
							console.log("got response:", response);
						});
					}}
				>
					Check Room
				</button>

				{currentRoomId && (
					<button
						type="button"
						className="btn btn-sm btn-default"
						onClick={() => {
							socket.emit("leave-room", currentRoomId);
							setCurrentRoomId("");
							resetRoom();
						}}
					>
						Leave Room
					</button>
				)}
			</div>
		</div>
	);
}
